export const Error = () => {
    return (
        <div className="flex justify-center items-center h-screen w-screen text-richblack-25 text-3xl">
         Error- 404 NOT FOUND
        </div>
    )

}